import React from 'react'
import * as Icon from 'react-bootstrap-icons';

import styles from './Forbidden.module.css';

export const Forbidden = () => {
  return (
    <div className={styles.container}>
        <div className="centrar mb-3"><Icon.SlashCircle size={50} /></div>
        <div className={"text-center " + styles.header}>¡Acceso negado!</div>
        <div className={"text-center " + styles.subheader}>No tienes permisos para realizar esta(s) acción(es)</div>
    </div>
  )
}
